import { PlanSlug } from 'common/types/enum'
import { useDefaultSubscription } from 'common/services/useDefaultSubscription'
import { useGetNumbersQuery } from 'common/services/useNumber'

/**
 * Hook to check if a user has an active subscription to a specific plan
 * @param planSlug - The plan to check for (e.g., PlanSlug.WHATSAPP)
 * @returns boolean indicating whether the user has the plan
 */
export const useHasPlan = (planSlug: PlanSlug): boolean => {
  const { subscriptionDetail } = useDefaultSubscription()
  const company_id = ((subscriptionDetail || {}).company_id ||
    '') as unknown as any

  const { data: numbers } = useGetNumbersQuery(
    {
      company_id,
    },
    {
      skip: !company_id || planSlug !== PlanSlug.WHATSAPP,
    },
  )

  // Currently only supports WhatsApp plan
  // Can be extended to support other plans in the future
  if (planSlug === PlanSlug.WHATSAPP) {
    return !!numbers && numbers.length > 0
  }

  return false
}
